import { graphql } from 'gql'

export const GET_WORKSPACE_KEY_VALUES_FOR_PREBID_VARIABLE = graphql(`
  query getWorkspaceKeyValuesForPrebidVariable {
    workspaceKeyValues {
      keyValue {
        name
      }
      status
    }
  }
`)
